import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import CmtAvatar from '../../../../../@coremat/CmtAvatar';
import Typography from '@material-ui/core/Typography';
import useStyles from '../ContactCell.style';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import { Button, Chip, IconButton, Tooltip } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';

const MovieCell = ({ movie }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const { uid, name, posters, product_type, state, download_id, id } = movie;

  const isCritics = location.pathname === '/content' ? true : false;
  const createDownloadURL = `/create-download/?ui=${uid}&download=${download_id}&type=${product_type}&published=${state}&name=${name}`;

  const handleDownloadType = () => {
    history.push(`/edit-download-type/?ui=${uid}&type=${product_type}`);
  };

  const handleRelationManager = () => {
    history.push(`/relation-managment/?movie=${id}`);
  };

  const handleShortCritics = () => {
    history.push(`/short-critic/?movie=${id}`);
  };

  const handleNews = () => {
    history.push(`/news/?movie=${id}`);
  };

  return (
    <TableRow className={classes.tableRowRoot}>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Box display="flex" alignItems="center">
            <Box mr={{ xs: 4, md: 5 }}>
              <CmtAvatar size={40} src={posters.small} alt={name} />
            </Box>

            <Box>
              <Typography className={classes.titleRoot} component="div" variant="h4">
                {name}
              </Typography>
            </Box>
          </Box>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        <Chip
          label={product_type === 'bundle' ? 'باندل' : 'آیتم'}
          size="small"
          color={product_type === 'bundle' ? 'secondary' : 'primary'}
        />
      </TableCell>
      {isCritics ? (
        <>
          <TableCell className={classes.tableCellRoot}>
            <Button color="primary" variant="outlined" onClick={handleShortCritics}>
              نقد کوتاه
            </Button>
          </TableCell>
          <TableCell className={classes.tableCellRoot}>
            <Button color="primary" variant="outlined" onClick={handleNews}>
              مدیریت اخبار
            </Button>
          </TableCell>
        </>
      ) : (
        <>
          <TableCell className={classes.tableCellRoot}>
            <Button color="primary" variant="outlined" href={createDownloadURL}>
              مدیریت دانلود
            </Button>
          </TableCell>
          <TableCell className={classes.tableCellRoot}>
            <Button color="primary" variant="outlined" onClick={handleRelationManager}>
              مدیریت ارتباطات
            </Button>
          </TableCell>
          <TableCell className={classes.tableCellRoot}>
            <Button color="primary" variant="outlined" onClick={handleDownloadType}>
              ویرایش اطلاعات
            </Button>
          </TableCell>
          <TableCell className={classes.tableCellRoot}>
            <Tooltip title="ویرایش">
              <IconButton color={"secondary"} size="small" target="_blank" href={`create-root-movie/?movie=${uid}`}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </>
      )}
    </TableRow>
  );
};

export default MovieCell;

MovieCell.prototype = {
  contact: PropTypes.object.isRequired,
  onShowContactDetail: PropTypes.func,
};
